import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const segments = {
  index: ({ params = {} } = {}) =>
    buildPath("/internal_api/community_segments", params),
  archived: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/community_segments/archived", params),
  detail: ({ id }: { id: number }) =>
    buildPath(`/internal_api/community_segments/${id}`),
  archive: ({ id }: { id: number }) =>
    buildPath(`/internal_api/community_segments/${id}/archive`),
  unarchive: ({ id }: { id: number }) =>
    buildPath(`/internal_api/community_segments/${id}/unarchive`),
  duplicate: ({ id }: { id: number }) =>
    buildPath(`/internal_api/community_segments/${id}/duplicate`),
  usageStatus: ({ id }: { id: number }) =>
    buildPath(`/internal_api/community_segments/${id}/usage_status`),
  audienceCount: ({ id }: { id: number }) =>
    buildPath(`/internal_api/community_segments/${id}/audience_count`),
  consumers: ({ id, params = {} }: { id: number; params?: Params }) =>
    buildPath(
      `/internal_api/community_segments/${id}/community_segment_consumers`,
      params,
    ),
};
